/**
 * Month-over-month change in a published rate, from the daily history.
 *
 * Compares today's rate with the most recent published row at least 30 days
 * old. Returns null when there is no row between 30 and 40 days old, so a gap
 * in the history never produces a misleading "change".
 */
export function monthOverMonthChange(
  history: { date: string; rates: Record<string, number> }[] | undefined,
  programKey: string,
  currentRate: number,
  now: Date = new Date()
): number | null {
  if (!history?.length || !Number.isFinite(currentRate)) return null;
  const isoDaysAgo = (n: number) => {
    const d = new Date(now);
    d.setUTCDate(d.getUTCDate() - n);
    return d.toISOString().slice(0, 10);
  };
  const latestAllowed = isoDaysAgo(30);
  const oldestAllowed = isoDaysAgo(40);
  const prior = [...history]
    .filter((r) => r.date <= latestAllowed && r.date >= oldestAllowed)
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .find((r) => Number.isFinite(r.rates?.[programKey]));
  if (!prior) return null;
  return Math.round((currentRate - prior.rates[programKey]) * 1000) / 1000;
}
